import React from 'react';
import FilaPartidoFixture from './FilaPartidoFixture.js';
import ColumnaBotoneraItem from '../../edicion/ColumnaBotoneraItem.js';
import * as UI from '../../constantes/UI.js';
import * as FuncionesFecha from '../../funciones/FuncionesFecha.js';
import * as FuncionesEquipo from '../../funciones/FuncionesEquipo.js';
import styles from './TablaInstanciaFixture.module.css';

/**
 * Tabla de partidos de una instancia (Único/Ida/Vuelta) de una etapa de definición.
 * Muestra los partidos existentes (solo lectura o en edición) y los faltantes (editables).
 */
const TablaInstanciaFixture = (props) => {
  const titulo = props.titulo;
  const tituloLocal = props.tituloLocal || 'Local';
  const tituloVisitante = props.tituloVisitante || 'Visitante';
  const partidosExistentes = props.partidosExistentes || [];
  const partidosFaltantes = props.partidosFaltantes || [];
  const equipos = props.equipos;
  const torneo = props.torneo;
  const mostrarZona = props.mostrarZona;
  const esVuelta = props.esVuelta || false;
  const puedeEditar = props.puedeEditar;
  const partidosEnEdicion = props.partidosEnEdicion;
  const partidoGrabandose = props.partidoGrabandose;
  const erroresFilaPartido = props.erroresFilaPartido;
  const onEditarPartido = props.onEditarPartido;
  const onCancelarEdicion = props.onCancelarEdicion;
  const onPartidoEnEdicionChange = props.onPartidoEnEdicionChange;
  const onGuardarEdicion = props.onGuardarEdicion;
  const onEliminarPartido = props.onEliminarPartido;
  const onPartidoChange = props.onPartidoChange;
  const onGuardarPartido = props.onGuardarPartido;
  const onCancelarPartido = props.onCancelarPartido;
  const { esMobile } = UI.useUI();

  const renderFilaExistente = (partido) => {
    const enEdicion = !!partidosEnEdicion[partido.id];

    if (enEdicion) {
      return (
        <FilaPartidoFixture
          key={`edit-${partido.id}`}
          partido={partidosEnEdicion[partido.id]}
          equipos={equipos}
          torneo={torneo}
          mostrarEquipoLibre={false}
          mostrarZona={mostrarZona}
          esVuelta={false}
          isGrabando={partidoGrabandose === partido.id}
          onChange={(partidoActualizado) =>
            onPartidoEnEdicionChange(partido.id, partidoActualizado)
          }
          onGuardar={() => onGuardarEdicion(partidosEnEdicion[partido.id])}
          onCancelar={() => onCancelarEdicion(partido.id)}
          errores={erroresFilaPartido[partido.id] || []}
        />
      );
    }

    const resultado =
      partido.resultadoLocal != null && partido.resultadoVisitante != null
        ? `${partido.resultadoLocal} - ${partido.resultadoVisitante}`
        : '-';

    return (
      <tr key={partido.id}>
        {!esMobile && <td className={styles.ordenPartido}>{partido.ordenPartido || ''}</td>}
        <td className={styles.fecha}>
          {esMobile
            ? FuncionesFecha.CamposToDiaMes(partido.mesPartido, partido.diaPartido)
            : FuncionesFecha.CamposToFechaCorta(
                partido.anioPartido,
                partido.mesPartido,
                partido.diaPartido
              )}
        </td>
        <td className={styles.equipoLocal}>
          {FuncionesEquipo.NombreEquipoTorneo(partido.equipoLocal, torneo)}
        </td>
        <td className={styles.resultado}>{resultado}</td>
        <td className={styles.equipoVisitante}>
          {FuncionesEquipo.NombreEquipoTorneo(partido.equipoVisitante, torneo)}
        </td>
        {mostrarZona && <td className={styles.zona}>{partido.zona || ''}</td>}
        <ColumnaBotoneraItem
          idItem={partido.id}
          onEditarItem={onEditarPartido}
          onEliminarItem={onEliminarPartido}
          className={styles.botones}
        />
      </tr>
    );
  };

  return (
    <div className={styles.grupo}>
      {titulo && <h4>{titulo}</h4>}
      <table className={styles.tabla}>
        <thead>
          <tr>
            {!esMobile && <th className={styles.ordenPartido}>#</th>}
            <th className={styles.fecha}>Día</th>
            <th className={styles.equipoLocal}>{tituloLocal}</th>
            <th className={styles.resultado}>Res</th>
            <th className={styles.equipoVisitante}>{tituloVisitante}</th>
            {mostrarZona && <th className={styles.zona}>Zona</th>}
            <th className={styles.botones}></th>
          </tr>
        </thead>
        <tbody>
          {partidosExistentes.map((partido) => renderFilaExistente(partido))}

          {puedeEditar &&
            partidosFaltantes.map((partido) => (
              <FilaPartidoFixture
                key={`faltante-${partido.idPartido}`}
                partido={partido}
                equipos={equipos}
                torneo={torneo}
                mostrarOrdenPartido={!esMobile}
                mostrarEquipoLibre={false}
                mostrarZona={mostrarZona}
                esVuelta={esVuelta}
                isGrabando={partidoGrabandose === partido.idPartido}
                onChange={(partidoActualizado) =>
                  onPartidoChange(partido.idPartido, partidoActualizado)
                }
                onGuardar={() => onGuardarPartido(partido)}
                onCancelar={() => onCancelarPartido(partido)}
                errores={erroresFilaPartido[partido.idPartido] || []}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TablaInstanciaFixture;
